export default "mdc-list {\n  padding: 0 !important;\n}\n\n.mdc-dialog__content {\n  padding: 0;\n}\n\n.all {\n  margin-bottom: 12px;\n}"